// Types
import { LeadStateType } from './States';

export type UserType = 'BUSINESS' | 'PRIVATE';

export enum LeadSource {
    FLEX = 'FLEX',
    ALD_ONLINE = 'ALD_ONLINE',
}

export interface GeneralState {
    leadSource: LeadSource;
    armadaCustomerId: string;
    leadId: string;
    leadState: LeadStateType;
    leasmanCustomerId: string;
    type: UserType;
    creationTimestamp: string;
}
